import React from "react";
import { useOutletContext } from "react-router";
import { TabMenuContainer } from "./styled";

const TabMenu = ({ active, setActive, menus }) => {
  const { theme } = useOutletContext();

  return (
    <TabMenuContainer className={`theme-${theme}`}>
      {menus.map((ele, idx) => (
        <li onClick={() => setActive(idx)} className={active === idx ? "active" : ""}>
          {ele}
        </li>
      ))}
    </TabMenuContainer>
  );
};

export default TabMenu;
